var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgDeleteConfirm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.161,
    height: 71.811,
    viewBox: "0 0 90.161 71.811"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-delete-confirm_svg__cls-2,.kpmg-delete-confirm_svg__cls-3{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:1.6px}.kpmg-delete-confirm_svg__cls-3{stroke-linejoin:round}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-delete-confirm_svg__ICN_Modal_confirmare_Stergere_Enabled",
    "data-name": "ICN_Modal confirmare Stergere_Enabled",
    transform: "translate(-942.92 -396.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-delete-confirm_svg__Path_948",
    d: "M44.5 13.39a4 4 0 016.929 0l41.11 63.81a4 4 0 01-3.465 6H6.926a4 4 0 01-3.465-6z",
    "data-name": "Path 948",
    transform: "translate(940 385)",
    fill: "#bc204b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-delete-confirm_svg__ICN_Sterge_Enabled",
    transform: "translate(788.5 166.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-delete-confirm_svg__Line_278",
    d: "M0 0h21.603",
    className: "kpmg-delete-confirm_svg__cls-2",
    "data-name": "Line 278",
    transform: "translate(188.5 266.155)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-delete-confirm_svg__Rectangle_410",
    className: "kpmg-delete-confirm_svg__cls-3",
    "data-name": "Rectangle 410"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h13.294v4.985H0z",
    transform: "translate(192.655 262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.8.8h11.694v3.385H.8z",
    transform: "translate(192.655 262)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-delete-confirm_svg__Line_279",
    d: "M0 0v11.847",
    className: "kpmg-delete-confirm_svg__cls-2",
    "data-name": "Line 279",
    transform: "translate(196.809 270.926)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-delete-confirm_svg__Line_280",
    d: "M0 0v11.847",
    className: "kpmg-delete-confirm_svg__cls-2",
    "data-name": "Line 280",
    transform: "translate(201.794 270.926)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-delete-confirm_svg__Path_932",
    d: "M-6891.694-22779.5l1.255 17.141h13.415l1.27-17.141",
    className: "kpmg-delete-confirm_svg__cls-3",
    "data-name": "Path 932",
    transform: "translate(7082.846 23049.516)"
  })))));
}

export default SvgKpmgDeleteConfirm;